import positionTransactionsFactory from '../transactions/position-transactions-factory';

export default positionTransactionsFactory({
  assetCategory: 'mmInstruments',
});
